/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchises_Timetobeat2Inputs */

const id_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu untuk menamatkan`)
};

const ms_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa untuk menamatkan`)
};

const da_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tid at gennemføre`)
};

const de_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielzeit`)
};

const en_us2_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time to beat`)
};

const es_es2_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo para completar`)
};

const es_mx2_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo para completar`)
};

const fil_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oras para matapos`)
};

const fr_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée de vie`)
};

const it_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo per completare`)
};

const hu_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítési idő`)
};

const nl_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speelduur`)
};

const no_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spilletid`)
};

const pl_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czas ukończenia`)
};

const pt_br2_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo para zerar`)
};

const pt_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo para completar`)
};

const ro_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timp de finalizare`)
};

const fi_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läpäisyaika`)
};

const sv_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tid att slå`)
};

const vi_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian hoàn thành`)
};

const tr_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitirme süresi`)
};

const cs_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doba dohrání`)
};

const bg_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Време за завършване`)
};

const ru_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время прохождения`)
};

const uk_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Час проходження`)
};

const ar_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وقت الإكمال`)
};

const hi_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा करने का समय`)
};

const th_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาในการเล่นจบ`)
};

const ja_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリア時間`)
};

const zh_cn2_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通关时间`)
};

const zh_hant1_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通關時間`)
};

const ko_franchises_timetobeat2 = /** @type {(inputs: Franchises_Timetobeat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`클리어 시간`)
};

/**
* | output |
* | --- |
* | "Time to beat" |
*
* @param {Franchises_Timetobeat2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const franchises_timetobeat2 = /** @type {((inputs?: Franchises_Timetobeat2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchises_Timetobeat2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_franchises_timetobeat2(inputs)
	if (locale === "ms") return ms_franchises_timetobeat2(inputs)
	if (locale === "da") return da_franchises_timetobeat2(inputs)
	if (locale === "de") return de_franchises_timetobeat2(inputs)
	if (locale === "en-US") return en_us2_franchises_timetobeat2(inputs)
	if (locale === "es-ES") return es_es2_franchises_timetobeat2(inputs)
	if (locale === "es-MX") return es_mx2_franchises_timetobeat2(inputs)
	if (locale === "fil") return fil_franchises_timetobeat2(inputs)
	if (locale === "fr") return fr_franchises_timetobeat2(inputs)
	if (locale === "it") return it_franchises_timetobeat2(inputs)
	if (locale === "hu") return hu_franchises_timetobeat2(inputs)
	if (locale === "nl") return nl_franchises_timetobeat2(inputs)
	if (locale === "no") return no_franchises_timetobeat2(inputs)
	if (locale === "pl") return pl_franchises_timetobeat2(inputs)
	if (locale === "pt-BR") return pt_br2_franchises_timetobeat2(inputs)
	if (locale === "pt") return pt_franchises_timetobeat2(inputs)
	if (locale === "ro") return ro_franchises_timetobeat2(inputs)
	if (locale === "fi") return fi_franchises_timetobeat2(inputs)
	if (locale === "sv") return sv_franchises_timetobeat2(inputs)
	if (locale === "vi") return vi_franchises_timetobeat2(inputs)
	if (locale === "tr") return tr_franchises_timetobeat2(inputs)
	if (locale === "cs") return cs_franchises_timetobeat2(inputs)
	if (locale === "bg") return bg_franchises_timetobeat2(inputs)
	if (locale === "ru") return ru_franchises_timetobeat2(inputs)
	if (locale === "uk") return uk_franchises_timetobeat2(inputs)
	if (locale === "ar") return ar_franchises_timetobeat2(inputs)
	if (locale === "hi") return hi_franchises_timetobeat2(inputs)
	if (locale === "th") return th_franchises_timetobeat2(inputs)
	if (locale === "ja") return ja_franchises_timetobeat2(inputs)
	if (locale === "zh-CN") return zh_cn2_franchises_timetobeat2(inputs)
	if (locale === "zh-Hant") return zh_hant1_franchises_timetobeat2(inputs)
	return ko_franchises_timetobeat2(inputs)
});
export { franchises_timetobeat2 as "franchises.timeToBeat" }